module.exports = __webpack_public_path__ + "files/3c9f20049d3582a090f03a5efe4bab35.svg";